export type MapEditorSaveAction = "submit" | "close";

/**
 * Save on the model-map and observations-map editors.
 *
 * Edit with no user edits closes without a request, so silent backfills
 * (default viewport, unit codes) stay unsaved. Create — including an
 * untouched paste — always submits, because those values are not stored yet.
 */
export function mapEditorSaveAction(input: {
  isCreate: boolean;
  dirtyBaselineReady: boolean;
  hasChanges: boolean;
}): MapEditorSaveAction {
  if (!input.isCreate && input.dirtyBaselineReady && !input.hasChanges) {
    return "close";
  }
  return "submit";
}
